<span *ngIf="shopKind===shopSoort.ONBEKEND" class="search-cursor pe-1"
  (contextmenu)="mainService.saveToClipBoard(partItemNumber)" tooltip="klik rechts om te kopiëren" placement="top"
  container="body">{{partItemNumber}}</span>
<span *ngIf="shopKind!==shopSoort.ONBEKEND" class="search-cursor pe-1" [routerLink]="['/iteminfo',partItemNumber]"
  [queryParams]="itemInfoService.getQueryParams(false,shopKind)"
  (contextmenu)="mainService.saveToClipBoard(partItemNumber)"
  tooltip="klik om te zoeken/crossen, klik rechts om te kopiëren" placement="top"
  container="body">{{partItemNumber}}</span>